import { render, staticRenderFns } from "./portCharges.vue?vue&type=template&id=fd7bdfb6&scoped=true&"
import script from "./portCharges.vue?vue&type=script&lang=js&"
export * from "./portCharges.vue?vue&type=script&lang=js&"
import style0 from "./portCharges.vue?vue&type=style&index=0&id=fd7bdfb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7bdfb6",
  null
  
)

export default component.exports